import Toast from 'react-native-toast-message';

import {AppRoute} from '../../../../models/AppRoute';
import {PaymentStore} from '../../../../stores/paymentStore';
import {ERROR_MESSAGE, SUCCESS_CHECK} from '../../../ToastBottom';

// Just trying to refactor things out of those platform-dependent
// CardTokeniserTill.tsx files looking to one day unify them as
// we have done with others.

const isIntegrationKeyAttr = (ie: any) => ie.attribute === 'integration_key';

const getTokeniserErrors = (errors: any) => {
  const tokeniserErrors: any[] = errors
    .filter((ie: any) => !isIntegrationKeyAttr(ie))
    .map((oe: any) => oe.message);

  const integrationError = errors.find(isIntegrationKeyAttr);
  if (integrationError) {
    tokeniserErrors.unshift(
      'There was an error in verifying your card. Please try again later',
    );
  }

  return tokeniserErrors;
};

export const showToastIfTokeniserErrors = (errors: any) => {
  const tokeniserErrors = getTokeniserErrors(errors);
  if (tokeniserErrors.length) {
    Toast.show({
      type: ERROR_MESSAGE,
      text1: tokeniserErrors.join('\n'),
    });
  }
};

export const createTillPaymentInstrumentAndShowToast = ({
  paymentStore,
  token,
  navigation,
  navigationTarget,
  onCancel,
}: {
  paymentStore: PaymentStore;
  token: any;
  navigationTarget: any;
  navigation: any;
  onCancel: () => void;
}) => {
  paymentStore
    .createTillUserPaymentInstrument(token)
    .then((result: any) => {
      if (result?.iframe_challenge_url) {
        onCancel();
        navigation.navigate(AppRoute.THREEDS_IFRAME_FULLSCREEN, {
          url: result.iframe_challenge_url,
          navigationTarget,
        });
      } else {
        paymentStore.setTillUserPaymentInstrument(result.payment_instrument);
        Toast.show({type: SUCCESS_CHECK});
        onCancel();
      }
    })
    .catch(error => {
      Toast.show({
        type: ERROR_MESSAGE,
        text1: error.message,
      });
      onCancel();
    });
};
